import { render, staticRenderFns } from "./MinimumOrderModal.vue?vue&type=template&id=7c524b1b"
import script from "./MinimumOrderModal.vue?vue&type=script&lang=js"
export * from "./MinimumOrderModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports